<template>
  <span>
    <v-icon class="score-dot" small> fiber_manual_record </v-icon>
    <v-icon class="score-dot second-dot" small v-if="second || third"> fiber_manual_record </v-icon>
    <v-icon class="score-dot third-dot" small v-if="third"> fiber_manual_record </v-icon>
  </span>
</template>

<script>
export default {
  name: 'StablefordScoringDots',
  props: {
    second: {
      type: Boolean,
      default: false,
    },
    third: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.score-dot {
  font-size: 0.5rem !important;
  position: absolute !important;
  top: 0;
  right: 0;
}
.second-dot {
  right: 0.4rem;
}
.third-dot {
  right: 0.8rem;
}
</style>
